import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import { Api, Cosmos } from './interface';
import { toast } from 'react-toastify';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import EquipmentMaintenanceFields from './equipmentMaintenanceFields';
import {
  ISO_SERVICE_INFORMATION,
  CTAG_PATTERN,
  CTAG_FORMAT_MESSAGE,
} from './constants';
import CapitalAssetSelector from './capitalAssetSelector';
import { CAPITAL_ASSET_FIELDS } from './constants';
import { getFieldValue, excludeGeekStorage } from './common'; // Import the utility function
class EntityCreate extends Component {
  constructor(props) {
    super(props);
    // const cookies = new Cookies();
    this.tableCellHover = [
      {
        '&:hover': {
          backgroundColor: '#BDBDBD',
        },
      },
    ];

    this.textInput = React.createRef();
    this.typeInput = React.createRef();
    this.commentInput = React.createRef();
    this.historyRef = React.createRef();

    this.state = {
      user: JSON.parse(localStorage.getItem('user')),
      entities: [],
      users: [],
      parentEntityList: [],
      items: [],
      filteredItems: [],
      entityTypes: [],
      template: [],
      filteredTemplate: [],
      statuses: [],
      metaOptions: [],
      fieldArray: [],
      currentEntity: {},
      currentEntityId: -1,
      isOpen: false,
      editing: false,
      cloning: false,
      creating: this.props.creating,
      deleting: false,
      statusEdit: -1,
      commenting: false,
      showHistory: true,
      comment: '',
      currentGroupChildren: [],
      currentHistory: [],
      filteredHistory: [],
      currentFilterText: '',
      filterTerm: '',
      filteredRows: [],
      rawTemplate: [],
      newEntityName: '',
      newEntityTotalQuantity: '',
      newEntityCurrentQuantity: '',
      newProjName: '',
      owner: null,
      entityOwner: null,
      allValidQty: true,
      sourceColumns: [
        { id: 'EntityName', label: 'Source Name', minWidth: 300 },
        { id: 'Quantity', label: 'Quantity', minWidth: 100, align: 'left' },
      ],
      lotId: null,
      componentQty: null,
      newEntityParent: null,
      srNo: null,
      fields: [],
      tabValue: '1',
      // For new equipment maintenance fields, -1 for Entity_DBID as we are creating a new equipment
      maintenanceData: { [-1]: {} },
      ISOFields: {},
      savingInProgress: false,

      // capital asset state
      capitalAsset: {
        isCapitalAsset: false,
        capitalFields: [], // Use capitalFields array instead of individual properties
        ioNumbers: [],
        poNumbers: [],
      },
    };
  }

  // handler for capital asset changes from CapitalAssetSelector
  handleCapitalAssetChange = (capitalAssetData) => {
    this.setState({
      capitalAsset: {
        isCapitalAsset: capitalAssetData.isCapitalAsset,
        capitalFields: capitalAssetData.capitalFields || [],
        ioNumbers: capitalAssetData.ioNumbers || [],
        poNumbers: capitalAssetData.poNumbers || [],
      },
    });
  };

  freeValues() {
    this.setState({
      newEPOMat: null,
      newProjName: '',
      owner: null,
      newEPOQty: '',
      entityOwner: null,
      lotId: null,
      componentQty: null,
      newEntityParent: null,
      srNo: null,
      parentEntityList: [],
      newEntityType: null,
      fields: [],
      capitalAsset: {
        isCapitalAsset: false,
        capitalFields: [],
        ioNumbers: [],
        poNumbers: [],
      },
    });
  }

  componentDidMount() {
    this.freeValues();

    Api({
      sp: 'getEntityTypes',
      json: {},
    }).then((types) => {
      types = types.filter((x) => {
        return this.props.level.length
          ? x.Level === this.props.level
          : ![
              'Material',
              'Location',
              'Site',
              'Geo',
              'Lab',
              'Building',
              'Floor',
            ].includes(x.Level);
      });

      if (
        this.props.type ||
        ['Geo', 'Lab', 'Building', 'Floor'].includes(this.props.level)
      ) {
        let newEntiyType = null;

        if (types.length === 1) {
          newEntiyType = types[0];
        } else {
          newEntiyType = types.find(
            (type) => type.EntityType === this.props.type
          );
        }
        this.setState({ newEntityType: newEntiyType });

        this.updateParentList(newEntiyType);

        Api({
          sp: 'getEntityCreateFieldsByType',
          json: { typeId: newEntiyType.EntityType_DBID },
        }).then((response) => {
          this.setState({ fields: response });
        });
      }

      Api({
        sp: 'getUsers',
        json: {},
      }).then((users) => {
        this.setState({
          users: users,
          entityTypes: types,
        });

        if (
          !this.props.type &&
          !['Geo', 'Lab', 'Building', 'Floor'].includes(this.props.level)
        ) {
          // material type
          this.setState({ newEntityType: null });
        }

        if (this.state.user) {
          let OID = this.state.user.oid;
          let user = users.find((user) => user.OID === OID);
          this.setState({ entityOwner: user });
        }
      });
    });

    // Fetch ISO maintenance fields
    // This is a separate API call to get ISO maintenance fields for equipment
    Api({
      sp: 'getISOMaintenanceFields',
      json: {},
    }).then((response) => {
      const isoFieldOptions = {};
      response.forEach((item) => {
        const key = item.EntityMetaType;
        if (!isoFieldOptions[key]) {
          isoFieldOptions[key] = {
            Label: item.EntityMetaType,
            DataType: item.DataType,
            EntityMetaType_DBID: item.EntityMetaType_DBID,
            EntityMetaOption: [],
          };
        }
        if (item.EntityMetaOption) {
          isoFieldOptions[key].EntityMetaOption.push(item.EntityMetaOption);
        }
      });
      this.setState({ ISOFields: isoFieldOptions });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        creating: this.props.creating,
        renaming: this.props.renaming,
      });
    }
  }

  updateParentList = (item) => {
    if (!item) {
      return;
    }
    Api({
      sp: 'getNonMaterialPaths',
      json: { id: item.EntityType_DBID },
    }).then((parents) => {
      if (this.props.level === 'Geo') {
        parents = [
          {
            Entity_DBID: 0,
            EntityName: 'No Parent',
            EntityType_DBID: 0,
            Path: 'No Parent',
          },
          ...parents,
        ];
      }
      this.setState({
        parentEntityList: [...excludeGeekStorage(parents)],
        newEntityType: item,
        newEntityParent: null,
      });
    });
  };

  addEntity = (edit) => {
    let fields = this.state.fields.filter((f) => f.IsUnique === 1);
    if (this.state.capitalAsset.isCapitalAsset) {
      fields = [
        ...fields,
        ...this.state.capitalAsset.capitalFields.filter(
          (f) => f.IsUnique === 1
        ),
      ];

      let ctagField = this.state.capitalAsset.capitalFields.find(
        (f) => f.EntityMetaType === CAPITAL_ASSET_FIELDS.C_TAG
      );
      let ctagValue = ctagField ? ctagField.EntityMetaValue : null;
      if (ctagValue && !CTAG_PATTERN.test(ctagValue)) {
        toast.error(CTAG_FORMAT_MESSAGE);
        this.setState({ savingInProgress: false });
        return;
      }
    }

    if (fields.length > 0) {
      Api({
        sp: 'getDuplicateEntity',
        json: {
          fields: fields,
        },
      }).then((r) => {
        if (r.length > 0) {
          let obj = r[0];
          toast.error(
            obj.EntityName +
              ' has the same ' +
              obj.MetaValue +
              ' for ' +
              obj.EntityMetaType
          );
          this.setState({ savingInProgress: false });
        } else {
          this.createEntity(edit);
        }
      });
    } else {
      this.createEntity(edit);
    }
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  createEntity = (edit) => {
    let user = this.state.entityOwner;
    if (!user) {
      // we can remove this as owner is a mandatory field now
      let OID = this.state.user.oid;
      user = this.state.users.find((user) => user.OID === OID);
    }

    let isoData = [];
    // Add ISO maintenance fields if applicable
    if (this.props.level === '' && this.state.maintenanceData[-1]) {
      isoData = Object.values(this.state.maintenanceData[-1]).filter(
        (item) =>
          item &&
          item.EntityMetaValue !== null &&
          item.EntityMetaValue !== undefined &&
          String(item.EntityMetaValue).trim() !== ''
      );
    }

    let apiPayload = {
      name: this.state.newEntityName?.trim(),
      typeId: this.state.newEntityType.EntityType_DBID,
      parentId: this.state.newEntityParent?.Entity_DBID ?? 0,
      owner: user?.User_DBID,
      matFlag: this.props.type ? 1 : 0,
      fields: this.state.fields,
      isoFlag: this.props.level === '' ? 1 : 0,
      isoData: isoData,
    };

    // Only add capital asset fields for Equipment level
    if (!this.props.level.length) {
      // Use the common utility function
      const selectedPONumber = getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.PO_NUMBER
      );
      const selectedIONumber = getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.IO_NUMBER
      );
      const ctag = getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.C_TAG
      );

      apiPayload.poNumber = selectedPONumber?.po_num || null;
      apiPayload.ioNumber = selectedIONumber?.io_num || null;
      apiPayload.poItemId = selectedPONumber?.pi_dbid || null;
      apiPayload.ctag = ctag || null;
    }

    Api({
      sp: 'addEntity',
      json: apiPayload,
    }).then((response) => {
      if (response[0].error) {
        toast.error(response[0].error);
        this.setState({ savingInProgress: false });
      } else {
        toast.success(response[0].EntityName + ' successfully created');
        this.setState({ savingInProgress: false });
        this.props.closeModal(edit ? response[0] : null);
      }

      if (['Component'].includes(this.props.type)) {
        Cosmos({
          cosmosApi: 'addDocuments',
          containerId: 'entityLineage',
          documentArr: [
            {
              entityDBID: response[0].Entity_DBID,
              lotQuantity: response[0].Quantity,
              parents: [],
              createdDate: new Date(),
              pk: this.props.type.toLowerCase(),
            },
          ],
        });
      }
    });
  };

  updateType = (type) => {
    this.setState({
      newEntityType: type,
      parentEntityList: [],
      newEntityParent: null,
    });
    if (type) {
      this.updateParentList(type);
    }
  };

  updatelotId = (text) => {
    this.setState({ lotId: text });
  };

  updateCompQty = (val) => {
    this.setState({ componentQty: val });
  };

  updatesrNo = (val) => {
    this.setState({ srNo: val });
  };

  updatesFields = (val, i) => {
    let fields = this.state.fields;
    fields[i].EntityMetaValue = val;
    this.setState({ fields: fields });
  };

  handleEquipmentMaintenanceFieldsChange = (value) => {
    this.setState({ maintenanceData: value });
  };

  /**
   * Checks the validity of maintenance data based on the current props and state.
   *
   * This function determines if the maintenance data is invalid by checking:
   * - If the `level` prop is an empty string.
   * - If any of the following fields in `maintenanceData` are missing or falsy (optional for 'For Indication Only' service information):
   *   - `ServiceInformation.EntityMetaValue`
   *   - `Periodicity.EntityMetaValue`
   *   - `LastServiceDate.EntityMetaValue`
   *   - `NextServiceDate.EntityMetaValue`
   *
   * @returns {boolean} Returns `true` if the maintenance data is invalid, otherwise `false`.
   */
  checkMaintenanceValidity = () => {
    let invalid = false;
    if (this.props.level === '') {
      if (
        !(
          this.state.maintenanceData[-1]?.ServiceInformation
            ?.EntityMetaValue === ISO_SERVICE_INFORMATION.INDICATION
        )
      ) {
        invalid =
          !this.state.maintenanceData[-1]?.Periodicity?.EntityMetaValue ||
          !this.state.maintenanceData[-1]?.LastServiceDate?.EntityMetaValue ||
          !this.state.maintenanceData[-1]?.NextServiceDate?.EntityMetaValue;
      }
    }
    return invalid;
  };

  isSaveButtonDisabled() {
    const { capitalAsset } = this.state;
    const isEquipmentLevel = !this.props.level.length;

    // Helper function to check if required capital fields are filled
    const areCapitalFieldsComplete = () => {
      // Use the common utility function
      const selectedPONumber = getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.PO_NUMBER
      );
      const selectedIONumber = getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.IO_NUMBER
      );
      const ctag = getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.C_TAG
      );

      return selectedPONumber && selectedIONumber && ctag && ctag.trim();
    };

    return (
      (!['Material'].includes(this.props.level) &&
        this.state.newEntityName.length < 3) ||
      !this.state.newEntityParent ||
      !this.state.entityOwner ||
      (isEquipmentLevel &&
        capitalAsset.isCapitalAsset &&
        !areCapitalFieldsComplete()) ||
      (this.state.fields.length > 0 &&
        this.state.fields.filter((f) => f.EntityMetaValue === '').length > 0) ||
      this.checkMaintenanceValidity()
    );
  }

  render = () => {
    const { capitalAsset } = this.state;
    const isEquipmentLevel = !this.props.level.length;

    // Enhanced logic: For capital assets, require PO, IO, AND ctag before showing other fields
    const shouldShowMainFields = () => {
      if (!isEquipmentLevel || !capitalAsset.isCapitalAsset) {
        return true;
      }

      // Use the common utility function
      const selectedPONumber = getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.PO_NUMBER
      );
      const selectedIONumber = getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.IO_NUMBER
      );

      return selectedPONumber && selectedIONumber;
    };

    return (
      <Modal
        className="create-ent"
        onEntered={() =>
          ['Material'].includes(this.props.level) ||
          ['Geo', 'Lab', 'Building', 'Floor'].includes(this.props.level)
            ? ''
            : this.typeInput.current.focus()
        }
        show={this.state.creating}
        onHide={() => this.props.closeModal()}
      >
        <Modal.Header>
          <Modal.Title>
            Add{' '}
            {this.props.level.length
              ? this.props.type
                ? this.props.type
                : this.props.level
              : 'Equipment'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="create-ent-body">
          {/* add tabs in the modal
             - Two tabs:
                 - "Details": Always shown. Contains fields for entity name, type, dynamic fields, location, and owner.
                 - "Service": Shown only when creating an Equipment entity. Contains maintenance-related fields via the `EquipmentMaintenanceFields` component.
          */}
          <TabContext value={this.state.tabValue}>
            <TabList
              onChange={this.handleTabChange}
              aria-label="basic tabs example"
            >
              <Tab
                className={
                  'details-tab' +
                  (!(this.props.level === '') ? ' no-pointer' : '')
                }
                value="1"
                label="Details"
              />

              {this.props.level === '' ? (
                <Tab className="details-tab" value="2" label="Service" />
              ) : (
                ''
              )}
            </TabList>
            <br />
            <TabPanel value="1" className="muiTabPanelDetails">
              <>
                {/* Capital Asset Selector - Only show for Equipment level */}
                {isEquipmentLevel && (
                  <CapitalAssetSelector
                    onCapitalAssetChange={this.handleCapitalAssetChange}
                    initialData={capitalAsset}
                  />
                )}
                {/* Main entity fields - only show when capital asset requirements are met */}
                {shouldShowMainFields() &&
                  !['Material'].includes(this.props.level) && (
                    <div className="mb-2">
                      Name <span style={{ color: 'red' }}>*</span>
                      <Form.Control
                        ref={this.textInput}
                        type="text"
                        placeholder="Entity Name"
                        onChange={(e) =>
                          this.setState({ newEntityName: e.target.value })
                        }
                        value={this.state.newEntityName}
                      />
                    </div>
                  )}
                {shouldShowMainFields() &&
                  this.props.level !== 'Material' &&
                  !['Geo', 'Lab', 'Building', 'Floor'].includes(
                    this.props.level
                  ) && (
                    <>
                      <div className="mb-2">
                        Type <span style={{ color: 'red' }}>*</span>
                        <Autocomplete
                          autoHighlight={true}
                          className="type-ahead"
                          ref={this.typeInput}
                          id="entity-type"
                          options={this.state.entityTypes}
                          getOptionLabel={(option) => option.EntityType}
                          hiddenlabel="true"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select Type"
                            />
                          )}
                          onChange={(_event, newType) => {
                            this.updateType(newType);
                          }}
                          value={this.state.newEntityType || null}
                        />
                      </div>
                    </>
                  )}
                {shouldShowMainFields() &&
                  this.state.fields.length > 0 &&
                  this.state.fields.map((field, i) => {
                    return (
                      <div className="mb-2" key={i}>
                        {field.EntityMetaType}{' '}
                        <span style={{ color: 'red' }}>*</span>
                        <Form.Control
                          type="text"
                          placeholder={field.EntityMetaType}
                          value={field.EntityMetaValue}
                          onChange={(e) =>
                            this.updatesFields(e.target.value.trim(), i)
                          }
                        />
                      </div>
                    );
                  })}
                {shouldShowMainFields() && (
                  <div className="mb-2">
                    Location
                    <Autocomplete
                      autoHighlight={true}
                      className="type-ahead"
                      id="parent-entity"
                      options={this.state.parentEntityList}
                      getOptionLabel={(option) => (option ? option.Path : '')}
                      hiddenlabel="true"
                      value={
                        this.state.newEntityType
                          ? this.state.newEntityParent
                          : null
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select Location"
                        />
                      )}
                      disabled={!this.state.newEntityType}
                      onChange={(_event, newParent) => {
                        this.setState({ newEntityParent: newParent });
                      }}
                    />
                  </div>
                )}
                {shouldShowMainFields() && (
                  <div className="mb-2">
                    Owner
                    <Autocomplete
                      autoHighlight={true}
                      className="type-ahead"
                      id="entity-owner"
                      value={this.state.entityOwner}
                      options={this.state.users}
                      getOptionLabel={(option) => option.UserName}
                      hiddenlabel="true"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select Owner"
                        />
                      )}
                      onChange={(_event, newOwner) => {
                        this.setState({ entityOwner: newOwner });
                      }}
                    />
                  </div>
                )}{' '}
              </>
            </TabPanel>
            <TabPanel value="2" className="muiTabPanelDetails">
              {this.props.level === '' ? (
                <EquipmentMaintenanceFields
                  level={this.props.level}
                  ISOFields={this.state.ISOFields}
                  isoData={this.state.maintenanceData}
                  entities={[{ Entity_DBID: -1 }]}
                  updateISOData={(value) =>
                    this.handleEquipmentMaintenanceFieldsChange(value)
                  }
                  canEdit={true}
                />
              ) : (
                ''
              )}
            </TabPanel>
          </TabContext>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-primary"
            onClick={() => this.props.closeModal()}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={(e) => {
              if (this.state.savingInProgress) {
                return;
              }
              this.setState({ savingInProgress: true }, () => {
                this.addEntity(false, e.currentTarget);
              });
            }}
            disabled={
              this.state.savingInProgress || this.isSaveButtonDisabled()
            }
          >
            Save
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              if (this.state.savingInProgress) {
                return;
              }
              this.setState({ savingInProgress: true }, () => {
                this.addEntity(true);
              });
            }}
            disabled={
              this.state.savingInProgress || this.isSaveButtonDisabled()
            }
          >
            Save And Edit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
}

export default EntityCreate;
